import * as React from "react";
const SvgChatMonitoringIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 20, fill: "none", viewBox: "0 0 18 20", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 7, r: 6, fill: "#ace6f9", style: {
  fill: "#ace6f9",
  fill: "color(display-p3 .6745 .902 .9765)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#defbff", d: "M2.278 4.581a.796.796 0 0 1 1.026-1.058l.129.052a.85.85 0 0 0 .634 0l1.486-.596a1.2 1.2 0 0 1 .894 0l1.486.596a.85.85 0 0 0 .634 0l.129-.052a.796.796 0 0 1 1.026 1.058.8.8 0 0 0 0 .638l.568 1.3a1.2 1.2 0 0 1 0 .961l-.568 1.301a.8.8 0 0 0 0 .638.796.796 0 0 1-1.026 1.058l-.129-.052a.85.85 0 0 0-.634 0l-1.486.596a1.2 1.2 0 0 1-.894 0l-1.486-.596a.85.85 0 0 0-.634 0l-.129.052a.796.796 0 0 1-1.026-1.058.8.8 0 0 0 0-.638l-.568-1.3a1.2 1.2 0 0 1 0-.961l.568-1.301a.8.8 0 0 0 0-.638", style: {
  fill: "#defbff",
  fill: "color(display-p3 .8706 .9843 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, fill: "#cbd5db", rx: 3.5, style: {
  fill: "#cbd5db",
  fill: "color(display-p3 .7961 .8351 .8577)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, stroke: "#fff", rx: 3.5, style: {
  stroke: "#fff",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinecap: "round", strokeLinejoin: "round", d: "M11 16.6c.72 0 1.68-.48 1.68-.48l1.619.48a.297.297 0 0 0 .301-.301l-.48-1.14c.458-.782.48-2.16.48-2.16a3.6 3.6 0 1 0-4.978 3.327c.437.18.658.274 1.378.274", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinejoin: "round", strokeWidth: 0.75, d: "M9.5 12H13m-3.5 2H12", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }));
export default SvgChatMonitoringIcon;
